<template>
  <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
    <!-- Sidebar Toggle (Topbar) -->
    <!-- <button id="sidebarToggleTop" class="btn btn-link d-md-none text-black rounded-circle mr-3">
      <i class="fa fa-bars"></i>
    </button>-->

    <!-- Topbar Search -->
    <button class="btn bg-white border-0" id="sidebarToggle">
      <img src="@/assets/ic-menu.svg" alt />
    </button>
    <form
      class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search"
    >
      Welcome To Paxel CMS 2.0
      <br />
      <b>{{data.fullname}}</b>
    </form>

    <div v-show="isShowClaimTodayHeader"  class="ml-auto mr-md-3 my-2 my-md-0 mw-100 text-right">
      <span class="text-primary"><b>Claim Amount Today</b></span>
      <br />
      <b>{{ claimToday | rupiah}}/{{ claimLimit | rupiah }}</b>
    </div>

    <!-- Topbar Navbar -->
    <!-- <ul class="navbar-nav ml-auto"> -->
    <ul class="navbar-nav">
      <!-- Nav Item - Search Dropdown (Visible Only XS) -->
      <!-- <li class="nav-item dropdown no-arrow d-sm-none">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="searchDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img src="@/assets/ic-search.svg" alt />
      </a>-->
      <!-- Dropdown - Messages -->
      <!-- <div
          class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
          aria-labelledby="searchDropdown"
        >
          <form class="form-inline mr-auto w-100 navbar-search">
            <div class="input-group">
              <input
                type="text"
                class="form-control border-1 small"
                placeholder="Search for..."
                aria-label="Search"
                aria-describedby="basic-addon2"
              />
              <div class="input-group-append">
                <button class="btn btn-secondary border-secondary bg-white py-0" type="button">
                  <img src="@/assets/ic-search.svg" alt />
                </button>
              </div>
            </div>
          </form>
        </div>
      </li>
      <form class="d-none d-sm-inline-block form-inline no-arrow mx-1 navbar-search mt-3">
        <div class="input-group">
          <input
            type="text"
            class="form-control border-1 small"
            placeholder="Search for..."
            aria-label="Search"
            aria-describedby="basic-addon2"
          />
          <div class="input-group-append">
            <button class="btn btn-secondary border-secondary bg-white py-0" type="button">
              <img src="@/assets/ic-search.svg" alt />
            </button>
          </div>
        </div>
      </form>-->
      <!-- Nav Item - Alerts -->
      <!-- <li class="nav-item dropdown no-arrow mx-1">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="alertsDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
      >-->
      <!-- <img src="@/assets/ic-notification.svg" alt /> -->
      <!-- Counter - Alerts -->
      <!-- <span class="badge badge-danger badge-counter">3+</span>
      </a>-->
      <!-- Dropdown - Alerts -->
      <!-- <div
          class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
          aria-labelledby="alertsDropdown"
        >
          <h6 class="dropdown-header bg-secondary border-secondary">Notification</h6>
          <a class="dropdown-item d-flex align-items-center" href="#">
            <div class="mr-3">
              <div class="icon-circle bg-primary">
                <i class="fas fa-file-alt text-white"></i>
              </div>
            </div>
            <div>
              <div class="small text-gray-500">December 12, 2019</div>
              <span class="font-weight-bold">A new monthly report is ready to download!</span>
            </div>
          </a>
          <a class="dropdown-item d-flex align-items-center" href="#">
            <div class="mr-3">
              <div class="icon-circle bg-success">
                <i class="fas fa-donate text-white"></i>
              </div>
            </div>
            <div>
              <div class="small text-gray-500">December 7, 2019</div>$290.29 has been deposited into your account!
            </div>
          </a>
          <a class="dropdown-item d-flex align-items-center" href="#">
            <div class="mr-3">
              <div class="icon-circle bg-warning">
                <i class="fas fa-exclamation-triangle text-white"></i>
              </div>
            </div>
            <div>
              <div class="small text-gray-500">December 2, 2019</div>Spending Alert: We've noticed unusually high spending for your account.
            </div>
          </a>
          <a class="dropdown-item text-center small text-gray-500" href="#">Show All Alerts</a>
        </div>
      </li>
      <div class="topbar-divider d-none d-sm-block"></div>-->

      <!-- Nav Item - User Information -->
      <li class="nav-item dropdown no-arrow">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="userDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="mr-2 d-none d-lg-inline text-gray-600 small"></span>
          <img v-if="data.image" class="img-profile rounded-circle" :src="data.image" />
          <img
            v-else
            class="img-profile rounded-circle"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRogvAnff-IUqdUshBXrme_oxwjofjtT4x1RyjZI5aF3ntLx3XI"
          />
        </a>
        <!-- Dropdown - User Information -->
        <div
          class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
          aria-labelledby="userDropdown"
        >
          <router-link to="/profile" class="dropdown-item">
            <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
            Profile
          </router-link>
          <!-- <router-link to="/profile" v-show="session.role == 'super_admin'" class="dropdown-item">
            <i class="fas fa-user-plus fa-sm fa-fw mr-2 text-gray-400"></i>
            Add User
          </router-link>-->
          <div class="dropdown-divider"></div>
          <b-link @click="logout()" class="dropdown-item">
            <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
            Logout
          </b-link>
        </div>
      </li>
    </ul>
  </nav>
  <!-- End of Topbar -->
</template>

<script>
import { mapState } from "vuex";
import { jwtDecode } from "jwt-decode";
export default {
  data() {
    return {
      header_name: "",
      data: [],
      claimToday: 0,
      claimLimit: 0,
      session: this.$session.get("jwt")
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      "internalUserModule/getInternalUserHeader",
      this.$session.get("jwt").id
    );

    if (this.$session.get("jwt").role === 'claim') {
      this.$store.dispatch("internalUserModule/getClaimTodayHeader");
    }
  },
  methods: {
    logout() {
      this.$swal({
        title: "Are you sure want to logout?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.$swal("See you next time", "Thx for using CMS Revamp 2.0");
          if (process.env.VUE_APP_ENABLE_GOOGLE_LOGIN == 'true') {
            let googleUser
            const storageGsic = this.$session.get("gsic")
            if(storageGsic) {
              googleUser = jwtDecode(storageGsic)
            }
  
            window.google.accounts.id.disableAutoSelect()
            if(googleUser && googleUser.sub) {
              window.google.accounts.id.revoke(googleUser.sub, done => {
                console.log(done);
              });
            }
  
            this.$store.dispatch("googleLogout", {}).then(async response => {
              this.$session.destroy();
              // for trigger reload, add router.go
              // reload needed for rerender google login button
              this.$router.push({ name: "login" }).then(() => { this.$router.go() })
            });
          }else {
            this.$store.dispatch("destroyToken").then(response => {
              this.$session.destroy();
              this.$router.push({ name: "login" });
            });
          }
        }
      });
    }
  },
  computed: {
    ...mapState("internalUserModule", {
      a: state => state.internal_user_header
    }),
    isShowClaimTodayHeader() {
      return this.data.role === 'claim' && ["cxAutoClaim", "cxDetailAutoClaim"].includes(this.$route.name);
    }
  },
  created() {
    this.$store.watch(
      state => state.internalUserModule.internal_user_header,
      (newValue, oldValue) => {
        this.data = newValue;
      }
    );
    this.$store.watch(
      state => state.internalUserModule.claim_today_header,
      (newValue, oldValue) => {
        console.log("claim today limit: ", newValue)
        if (newValue) {
          this.claimToday = newValue.amount_used
          this.claimLimit = newValue.amount_limit
        }
      }
    );
    this.header_name = process.env.VUE_APP_NAME;
  }
};
</script>

<style scoped>
.btn:focus {
  outline: none;
  border-color: white;
}
</style>
